import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useViewSingleClient } from "../../hooks/clients/viewSingle";
import { useViewIndustryQuery } from "../../hooks/industry/industryList";
import { useViewCategory } from "../../hooks/categorys/category.showall";
import { ArrowLeft } from "lucide-react";
import FallbackImage from "../../components/common/fallbackImage";

const ViewClient = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, isLoading, isError } = useViewSingleClient(id);
  const { data: industriesData } = useViewIndustryQuery();
  const { data: categoriesData } = useViewCategory();

  const client = data?.data?.client || data?.client || data?.data || data;

  const industriesList = React.useMemo(() => {
    if (!industriesData) return [];
    const list =
      industriesData?.data?.industry ||
      industriesData?.data?.industries ||
      industriesData?.data ||
      industriesData?.industry ||
      industriesData?.industries ||
      industriesData;
    return Array.isArray(list) ? list : [];
  }, [industriesData]);

  const categoriesList = React.useMemo(() => {
    if (!categoriesData) return [];
    const list =
      categoriesData?.data?.category ||
      categoriesData?.data?.categories ||
      categoriesData?.data ||
      categoriesData?.category ||
      categoriesData?.categories ||
      categoriesData;
    return Array.isArray(list) ? list : [];
  }, [categoriesData]);

  const getIndustryTitle = (val) => {
    if (!val || (Array.isArray(val) && val.length === 0)) return "-";

    const items = (Array.isArray(val) ? val : [val]).filter(Boolean);
    if (items.length === 0) return "-";

    return items
      .map((item) => {
        // If it's already an object with title/name, use it
        if (typeof item === "object" && (item?.title || item?.name)) {
          return item.title || item.name;
        }

        const id = typeof item === "string" ? item : item?._id || item?.id;
        const found = industriesList.find(
          (i) => String(i._id || i.id) === String(id),
        );
        if (found) return found.title || found.name || found.label;
        if (typeof item === "object")
          return (
            item?.title ||
            item?.name ||
            item?.label ||
            item?.industryName ||
            item?.industry_name ||
            "-"
          );
        return item;
      })
      .join(", ");
  };

  const getCategoryTitle = (val) => {
    if (!val || (Array.isArray(val) && val.length === 0)) return "-";

    const items = (Array.isArray(val) ? val : [val]).filter(Boolean);
    if (items.length === 0) return "-";

    return items
      .map((item) => {
        // If it's already an object with title/name, use it
        if (typeof item === "object" && (item?.title || item?.name)) {
          return item.title || item.name;
        }

        const id = typeof item === "string" ? item : item?._id || item?.id;
        const found = categoriesList.find(
          (c) => String(c._id || c.id) === String(id),
        );
        if (found) return found.title || found.name || found.label;
        if (typeof item === "object")
          return (
            item?.title ||
            item?.name ||
            item?.label ||
            item?.categoryName ||
            item?.category_name ||
            "-"
          );
        return item;
      })
      .join(", ");
  };

  if (isLoading) return <div>Loading client...</div>;
  if (isError) return <div>Error loading client</div>;

  return (
    <>
      <h5>
        <button className="back-btn" onClick={() => navigate(-1)}>
          <ArrowLeft size={18} /> Back to Clients
        </button>
      </h5>

      {/* <h2 style={{ color: "#5C308D", marginBottom: "20px" }}>
        {" "}
        {client?.name || "Client"} Details
      </h2> */}
      <div className="page-body" style={{ marginTop: 30 }}>
        <div
          className="client-view-card"
          style={{
            padding: "20px",
            border: "1px solid #ddd",
            borderRadius: "10px",
            background: "#fff",
            width: "100%",
          }}
        >
          {client?.logo && (
            <FallbackImage
              src={client.logo}
              alt="Client Logo"
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                marginBottom: "20px",
                borderRadius: "50%",
              }}
            />
          )}

          <div className="client-grid">
            <div className="field">
              <span className="label">Client</span>
              <span className="value">{client?.name || "-"}</span>
            </div>

            <div className="field">
              <span className="label">Email</span>
              <span className="value">{client?.email || "-"}</span>
            </div>

            <div className="field">
              <span className="label">Phone</span>
              <span className="value">{client?.phone || "-"}</span>
            </div>

            <div className="field">
              <span className="label">Industry</span>
              <span className="value">
                {getIndustryTitle(
                  client?.industry ||
                    client?.industries ||
                    client?.industry_id ||
                    client?.industryId ||
                    client?.industryName ||
                    client?.industry_name ||
                    client?.industry_info ||
                    client?.industryData,
                )}
              </span>
            </div>
            <div className="field">
              <span className="label">Category</span>
              <span className="value">
                {getCategoryTitle(
                  client?.category ||
                    client?.categories ||
                    client?.category_id ||
                    client?.categoryId ||
                    client?.categoryName ||
                    client?.category_name ||
                    client?.category_info ||
                    client?.categoryData,
                )}
              </span>
            </div>

            <div className="field">
              <span className="label">Address</span>
              <span className="value">{client?.country || "-"}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewClient;
